// utils/socket.ts
import { io, Socket } from "socket.io-client";

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL;

export const socket: Socket = io(SOCKET_URL, {
  withCredentials: true,
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1500,
});

socket.on("connect", () => {
  console.log("🟢 Connected to Socket.IO:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.log("🔴 Socket disconnected:", reason);
});

// import { io, Socket } from 'socket.io-client';

// // Use your backend’s URL (update if needed)
// const SOCKET_URL = import.meta.env.VITE_API_BASE_URL?.replace('/api', '') || 'http://localhost:4000';

// export const socket: Socket = io(SOCKET_URL, {
//   withCredentials: true,
//   transports: ['websocket'],
//   reconnection: true,
//   reconnectionAttempts: 5,
//   reconnectionDelay: 2000,
// });

// socket.on('connect', () => {
//   console.log('🟢 Connected to Socket.IO server:', socket.id);
// });

// socket.on('disconnect', (reason) => {
//   console.warn('🔴 Socket disconnected:', reason);
// });
